import React from "react";

function VerifiedGreen(props: any) {
  return (
<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.3019 6.05314C12.314 6.19963 12.3202 6.34783 12.3202 6.49742C12.3202 9.43476 9.93535 11.8197 6.998 11.8197C4.06066 11.8196 1.67577 9.43475 1.67577 6.49741C1.67578 3.56007 4.06068 1.17517 6.99802 1.17518C7.76911 1.17518 8.50212 1.33954 9.16385 1.63505" stroke="#0F7A04" stroke-width="1.5" stroke-linecap="round"/>
<path d="M12.3253 2.23865L6.99693 7.57225L5.39844 5.97382" stroke="#4da090" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
}

export default VerifiedGreen;
